/* eslint-disable */
import saveStoreDraft from "../../utils/saveStoreDraft";
import useStoreFormDraft from "../../hooks/useStoreFormDraft";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { doc } from "firebase/firestore";
import { db } from "../../firebase";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import apicache from "../../components/clearCach/clear";
import {
  Facebook,
  Instagram,
  MessageSquareDot,
  PhoneIncoming,
  Save,
} from "lucide-react";
import { FaTiktok, FaWhatsapp } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

function SocialMedia() {
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const MySwal = withReactContent(Swal);
  const [showSideBar, setShowSideBar] = useState(true);
  const products = useSelector((state) => state.ProductsReducer);
  const [data, setData] = useStoreFormDraft(store);
  const baseURL = "https://m.me/";
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    apicache(account, products);
    try {
      await saveStoreDraft(doc(db, "store", data.id), store, data);
      Swal.fire({
        icon: "success",
        title: t("footerSettings.swal_success_title"),
        confirmButtonText: t("footerSettings.swal_success_confirm"),
        confirmButtonColor: "rgb(141, 93, 167)",
      });
    } catch (error) {
      Swal.fire({ icon: "error", title: t("ui.notSaved"), confirmButtonText: t("ship.ok") });
    }
  };

  const message = (e) => {
    e.preventDefault();
    MySwal.fire({
      title: (
        <a href="https://m.me/F0orweb" target="_blank" rel="noreferrer">
          {t("footerSettings.swal_contact_link")}
        </a>
      ),
      isDismissed: true,
    });
  };

  return (
    <div className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen" dir={isRTL ? "rtl" : "ltr"}>
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full dark:!bg-[#181819]"
          style={{ flex: 1, backgroundColor: "#fbf8fc" }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] flex flex-col gap-y-6">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-0">
                  {t("socialMediaSettings.page_title")}
                </h2>
                <p className="text-gray-600 dark:!text-gray-400 mb-0">
                  {t("socialMediaSettings.page_subtitle")}
                </p>
              </div>
            </div>
          </div>

          {/* Main Content */}
          {!!data && (
            <form onSubmit={!!account.store ? handleSubmit : message}>
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-6 m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="mb-5">
                  <h3 className="text-lg font-semibold text-[#9e68ba] mb-4">
                    {t("socialMediaSettings.account_info_title")}
                  </h3>
                  <p className="text-gray-600 dark:text-gray-400 text-sm mb-4">
                    {t("socialMediaSettings.account_info_description")}
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* Facebook */}
                  <div>
                    <label className="block text-[#9e68ba] text-sm font-medium mb-2">
                      {t("socialMediaSettings.facebook_label")}
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <Facebook size={18} className="text-gray-400" />
                      </div>
                      <input
                        type="text"
                        placeholder={t("socialMediaSettings.facebook_placeholder")}
                        value={data.SocialMedia.facebook}
                        onChange={(e) =>
                          setData({
                            ...data,
                            SocialMedia: {
                              ...data.SocialMedia,
                              facebook: e.target.value,
                            },
                          })
                        }
                        className="w-full pr-4 pl-10 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent dark:!bg-[#141414] dark:!text-gray-200"
                      />
                    </div>
                  </div>

                  {/* Instagram */}
                  <div>
                    <label className="block text-[#9e68ba] text-sm font-medium mb-2">
                      {t("socialMediaSettings.instagram_label")}
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <Instagram size={18} className="text-gray-400" />
                      </div>
                      <input
                        type="text"
                        placeholder={t("socialMediaSettings.instagram_placeholder")}
                        value={data.SocialMedia.insta}
                        onChange={(e) =>
                          setData({
                            ...data,
                            SocialMedia: {
                              ...data.SocialMedia,
                              insta: e.target.value,
                            },
                          })
                        }
                        className="w-full pr-4 pl-10 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent dark:!bg-[#141414] dark:!text-gray-200"
                      />
                    </div>
                  </div>

                  {/* Messenger */}
                  <div>
                    <label className="block text-[#9e68ba] text-sm font-medium mb-2">
                      {t("socialMediaSettings.messenger_label")}
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <MessageSquareDot size={18} className="text-gray-400" />
                      </div>
                      <input
                        type="text"
                        placeholder={t("socialMediaSettings.messenger_placeholder")}
                        value={`${baseURL}${data.SocialMedia?.messenger || ""}`}
                        onChange={(e) =>
                          setData({
                            ...data,
                            SocialMedia: {
                              ...data.SocialMedia,
                              messenger: e.target.value.replace(baseURL, ""),
                            },
                          })
                        }
                        className="w-full pr-4 pl-10 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent dark:!bg-[#141414] dark:!text-gray-200"
                      />
                    </div>
                    <p className="text-xs text-gray-500 dark:!text-gray-400 mt-1 pr-1">
                      {t("socialMediaSettings.messenger_note", { url: baseURL })}
                    </p>
                  </div>

                  {/* Phone */}
                  <div>
                    <label className="block text-[#9e68ba] text-sm font-medium mb-2">
                      {t("socialMediaSettings.phone_label")}
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <PhoneIncoming size={18} className="text-gray-400" />
                      </div>
                      <input
                        type="text"
                        placeholder={t("socialMediaSettings.phone_placeholder")}
                        value={data.SocialMedia.phone}
                        onChange={(e) =>
                          setData({
                            ...data,
                            SocialMedia: {
                              ...data.SocialMedia,
                              phone: e.target.value,
                            },
                          })
                        }
                        className="w-full pr-4 pl-10 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent dark:!bg-[#141414] dark:!text-gray-200"
                      />
                    </div>
                  </div>
                  <div>
                    <label className="block text-[#9e68ba] text-sm font-medium mb-2">
                      {t("socialMediaSettings.tiktok_label")}
                    </label>

                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <FaTiktok size={18} className="text-gray-400" />
                      </div>

                      <input
                        type="text"
                        placeholder={t("socialMediaSettings.tiktok_placeholder")}
                        value={data.SocialMedia.tiktok}
                        onChange={(e) =>
                          setData({
                            ...data,
                            SocialMedia: {
                              ...data.SocialMedia,
                              tiktok: e.target.value,
                            },
                          })
                        }
                        className="w-full pr-4 pl-10 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent dark:!bg-[#141414] dark:!text-gray-200"
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-[#9e68ba] text-sm font-medium mb-2">
                      {t("socialMediaSettings.whatsapp_label")}
                    </label>

                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                        <FaWhatsapp size={18} className="text-gray-400" />
                      </div>

                      <input
                        type="text"
                        placeholder={t("socialMediaSettings.whatsapp_placeholder")}
                        value={data.SocialMedia.whatsapp}
                        onChange={(e) =>
                          setData({
                            ...data,
                            SocialMedia: {
                              ...data.SocialMedia,
                              whatsapp: e.target.value,
                            },
                          })
                        }
                        className="w-full pr-4 pl-10 py-3 border border-gray-300 dark:!border-[#3c3a3d] rounded-lg focus:ring-2 focus:ring-purple-200 focus:border-transparent dark:!bg-[#141414] dark:!text-gray-200"
                      />
                    </div>
                  </div>
                </div>

                <div className="flex justify-center mt-8">
                  <button
                    type="submit"
                    className="py-2 px-6 rounded-lg bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium flex items-center gap-2 transition-colors shadow-sm"
                  >
                    <Save size={18} />
                    {t("socialMediaSettings.submit_button")}
                  </button>
                </div>
              </div>

            </form>
          )}

          <Footer />
        </div>
      </div>
    </div>
  );
}

export default SocialMedia;
